import React from 'react'
import { useState } from 'react';
import { IoEyeOutline } from "react-icons/io5";
import { FiEyeOff } from "react-icons/fi";
import { Link } from 'react-router-dom';



function SignupForm() {
    const [showPassword, setShowPassword] = useState(false);
    return (
        <>
            <div className='bg-[#fff] rounded-lg  w-full max-w-[450px] md:w-[450px] py-8 md:py-10 px-4 md:px-3'>
                <h1 className='text-[#000] font-bold text-[20px] break-all animate-textMove text-shadow-glow'>
  https://globeomni.com
</h1>

                <div className='px-2 md:px-4 py-2 flex flex-col gap-3'>

                    <h1 className='text-[#000] font-[600] text-[26px] md:text-[28px]'>Sign in</h1>

                    <span className='text-gray-600 font-[500] text-sm md:text-base'>
                        Don't have an account yet?
                        <span className='text-[#37715d] text-[14px] underline cursor-pointer ml-2'>
                            <Link to ='/login'>
                             Login here!
                            </Link>
                        </span>
                    </span>

                    <div className='w-[100%] h-[50px] text-[#576071] border-[#576071] border-[1px] p-2 rounded-md focus:bg-white'>
                        <input
                            type="text"
                            placeholder='Username'
                            className='outline-none w-full'
                        />
                    </div>

                    <div className='w-[100%] mt-2 h-[50px] text-[#576071] flex justify-between border-[#576071] border-[1px] p-2 rounded-md items-center'>
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder='Password'
                            className='outline-none bg-white w-full'
                        />

                        {showPassword ? (
                            <IoEyeOutline
                                onClick={() => setShowPassword(!showPassword)}
                                className='cursor-pointer ml-2'
                            />
                        ) : (
                            <FiEyeOff
                                onClick={() => setShowPassword(!showPassword)}
                                className='cursor-pointer ml-2'
                            />
                        )}
                    </div>
                    <div className='w-[100%] mt-2 h-[50px] text-[#576071] flex justify-between border-[#576071] border-[1px] p-2 rounded-md items-center'>
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder='Consfirm Password'
                            className='outline-none bg-white w-full'
                        />

                        {showPassword ? (
                            <IoEyeOutline
                                onClick={() => setShowPassword(!showPassword)}
                                className='cursor-pointer ml-2'
                            />
                        ) : (
                            <FiEyeOff
                                onClick={() => setShowPassword(!showPassword)}
                                className='cursor-pointer ml-2'
                            />
                        )}
                    </div>

                     <div className='w-[100%] mt-2 h-[50px] text-[#576071] border-[#576071] border-[1px] p-2 rounded-md focus:bg-white'>
                        <input
                            type="number"
                            placeholder='Mobile Number'
                            className='outline-none w-full'
                        />
                    </div>
                     <div className='w-[100%] mt-2 h-[50px] text-[#576071] border-[#576071] border-[1px] p-2 rounded-md focus:bg-white'>
                        <input
                            type="Email"
                            placeholder='Email id'
                            className='outline-none w-full'
                        />
                    </div>

                    <div className='flex justify-between flex-wrap gap-2 w-[100%] mt-2'>
                        <div className='flex items-center'>
                            <input
                                type="checkbox"
                                id="agree"
                                className='w-4 h-4 accent-[#37715d] rounded-lg'
                            />
                            <label htmlFor="agree" className='ml-2 text-gray-600 font-[500] text-sm md:text-base'>
                                I agree to the 
                            </label>
                         <span className='text-[#37715d] text-[14px] font-bold cursor-pointer ml-2 underline'>
                            Privacy & Policy
                        </span>
                        </div>

                        
                    </div>

                    <button className='bg-[#37715d] hover:bg-[#265041] text-[#fff] py-2 rounded-md font-semibold mt-4 w-full'>
                        Sign up
                    </button>

                </div>
            </div>
        </>
    )
}

export default SignupForm
